import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getSuppliers = async (config = {}) => {
  const res = await axiosInstance.get('supplier/get-suppliers', config);
  return res.data;
};

export const getSupplierById = async (id) => {
  const res = await axiosInstance.get(`supplier/get-suppliers/${id}`);
  return res.data;
};

export const addSupplier = async (supplier, config = {}) => {
  const res = await axiosInstance.post('supplier/add-supplier', supplier, config);
  return res.data;
};

export const updateSupplier = async (id, supplier) => {
  const res = await axiosInstance.post('supplier/update-supplier', { ...supplier, Id: id });
  return res.data;
};

export const deleteSupplier = async (id, config = {}) => {
  const res = await axiosInstance.delete('supplier/delete-supplier', {
    ...config,
    params: { ...config.params, supplierId: id }
  });
  return res.data;
};

export const searchSuppliers = async (query, config = {}) => {
  const res = await axiosInstance.get(`supplier/search-supplier`, { params: { q: query }, ...config });
  return res.data;
};

// ✅ Add new search by name endpoint
export const searchSuppliersByName = async (name, config = {}) => {
  const res = await axiosInstance.get('supplier/search-supplier-by-name', {
    ...config,
    params: { ...config.params, name }
  });
  return res.data;
};